import label from "@/lang/StaticLabels.js";

// PMRPVALVS Navbar  - برنامه ریزی تولید شیرآلات -----------------------------------------------
let navItems = [
  {
    title: label.modules.pmrpValvs,
    icon: "mdi-map-marker-radius",
    to: false,
  },
  {
    to: "PMRPVALVSDashboard",
    label: label.menu.dashboard,
    icon: "pi pi-home",
    active: false,
    subItems: false,
    divider: true,
  },
  {
    to: null,
    label: label.menu.baseInformation,
    icon: "pi pi-database",
    active: false,
    subItems: [
      {
        to: "PMRPVALVSCommodityAdditionalInfo",
        label: label.menu.commodityAdditionalInfo,
        metaLabel: label.page.commodityAdditionalInfo,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMRPVALVSSaleType",
        label: label.menu.saleType,
        metaLabel: label.page.saleType,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMRPVALVSProductionGroups",
        label: label.menu.productionGroups,
        metaLabel: label.page.productionGroups,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMRPVALVSPurchaseContracts",
        label: label.menu.purchaseContracts,
        metaLabel: label.page.purchaseContracts,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMRPVALVSInspectionLevel",
        label: label.menu.inspectionLevel,
        metaLabel: label.page.inspectionLevel,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMRPVALVSModiranMapping",
        label: label.menu.modiranMapping,
        metaLabel: label.page.modiranMapping,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMRPVALVSSystemSetting",
        label: label.menu.settings,
        metaLabel: label.page.settings,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
  {
    to: null,
    label: label.menu.operation,
    icon: "mdi-wrench-outline",
    active: false,
    subItems: [
      {
        to: null,
        label: label.menu.order,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PMRPVALVSAddOrder",
            label: label.menu.addOrder,
            metaLabel: label.page.addOrder,
            icon: "mdi-circle-small",
          },
          {
            to: "PMRPVALVSOrderList",
            label: label.menu.orderList,
            metaLabel: label.page.order,
            icon: "mdi-circle-small",
          },
          {
            to: "PMRPVALVSReservationList",
            label: label.menu.commodityReservationList,
            metaLabel: label.page.commodityReservationList,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.cartable,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PMRPVALVSSaleCartable",
            label: label.menu.saleCartable,
            metaLabel: label.page.SaleCartable,
            icon: "mdi-circle-small",
          },
          {
            to: "PMRPVALVSTechnicalCartable",
            label: label.menu.technicalCartable,
            metaLabel: label.page.technicalCartable,
            icon: "mdi-circle-small",
          },
          {
            to: "PMRPVALVMapConfirmCartable",
            label: label.menu.mapConfirmCartable,
            metaLabel: label.page.mapConfirmCartable,
            icon: "mdi-circle-small",
          },
          {
            to: "PMRPVALVMapPlanCartable",
            label: label.menu.planCartable,
            metaLabel: label.page.planCartable,
            icon: "mdi-circle-small",
          },
          {
            to: "PMRPVALVConfirmDeliveryDate",
            label: label.menu.deliveryTimeConfirm,
            metaLabel: label.page.deliveryTimeConfirm,
            icon: "mdi-circle-small",
          },
        ],
      },
    ],
  },
];

export default navItems;
